import clsx from 'clsx';

import { Icon, IconButton } from '@atom/mui';
import markerUtilities from '@atom/utilities/markerUtilities';

import classes from './drawerContent.module.css';

interface Props {
  title?: string;
  subtitle?: string;
  markerId?: number;
  attributes?: { [key: string]: any };
  onCancel: () => void;
}

const KmlPlacemark = ({
  title,
  subtitle,
  markerId,
  attributes = {},
  onCancel,
}: Props) => {
  const icon = markerUtilities.getKmlSvg(markerId);
  return (
    <div className={classes.container}>
      <div className={classes.trayContainer}>
        <div className={classes.kmlHeader}>
          <div className={classes.kmlHeaderTitleContainer}>
            <img
              style={{ height: 40, width: 40, marginRight: '0.5rem' }}
              src={icon}
            />
            <div>
              <div className={classes.kmlHeaderTitle}>{title}</div>
              <div className={classes.kmlAttribute}>{subtitle}</div>
            </div>
          </div>
          <IconButton onClick={onCancel}>
            <Icon>close</Icon>
          </IconButton>
        </div>
        <div className={classes.kmlAttributes}>
          {Object.entries(attributes).map(([key, value], index) => (
            <div key={index} className={classes.kmlRow}>
              <div className={clsx(classes.kmlAttribute, classes.label)}>
                {key}
              </div>
              <div className={classes.kmlValue}>{value || '-'}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KmlPlacemark;
